export default "__VITE_ASSET__DFHldMeF__"